import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "15",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.48.405H3.509A3.516 3.516 0 0 0 0 3.913v6.983c0 1.921 1.577 3.498 3.508 3.498h6.984A3.516 3.516 0 0 0 14 10.885V3.913A3.53 3.53 0 0 0 10.48.405M4.664 11.729H2.665V5.956h1.998zm-1.01-6.661A1.02 1.02 0 0 1 2.63 4.046c0-.566.455-1.021 1.022-1.021.566 0 1.021.455 1.021 1.021a1.033 1.033 0 0 1-1.021 1.022m7.682 6.661H9.66V8.931c0-.677-.089-1.543-1.01-1.543-.944 0-1.1.733-1.1 1.499v2.842H5.885V5.956H7.44v.777h.044c.244-.444.81-.788 1.699-.788 1.832 0 2.153 1.054 2.153 2.62z"
    }, null, -1)
  ])))
}
export default { render: render }